import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

export interface WeeklyScheduleDates {

}

interface ApiResponse {
    data: {
        data: WeeklyScheduleDates[];
    };
}

interface WeeklyScheduleDatesState {
    data: WeeklyScheduleDates[];
    loading: boolean;
    error: string | null;
}

const COOKPORT = import.meta.env.VITE_COOK_PORT;
const COOKURL = import.meta.env.VITE_API_COOK_URL;

export const customSearchWeeklyScheduleDates = createAsyncThunk<
    WeeklyScheduleDates[],
    { weeklyScheduleId: any },
    { rejectValue: string }
>(
    'WeeklyScheduleDates/customSearchWeeklyScheduleDates',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<any>(
                'custom_search_weekly_schedule_dates',
                COOKPORT,
                COOKURL,
                config
            );
            return response.data.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);
export const customSearchWeeklyScheduleDatesSlice = createSlice({
    name: 'WeeklyScheduleDates',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as WeeklyScheduleDatesState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(customSearchWeeklyScheduleDates.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(customSearchWeeklyScheduleDates.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(customSearchWeeklyScheduleDates.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            });
    },
});

export default customSearchWeeklyScheduleDatesSlice.reducer;
